import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';

import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-pickup-button',
    templateUrl: './pickup-button.shared.component.html',
    styleUrls: ['./pickup-button.shared.component.scss']
})
export class PickupButtonComponent {
    @Input() public mode: OLO.Components.PICKUP_MODE = 'current-location';
    @Input() public projection: 'local' | 'global' = 'global';
    @Input() public iconRight: string = 'down';
    @Input() public iconLeft: string;
    @Input() public label: string;
    @Input() public options: OLO.Ordering.IPickupTime[] = [];
    @Input() public optionsAmount: number = null;
    @Input() public dropdownWidth: OLO.Components.DROPDOWN_WIDTH = 'sm';
    @Input() public size: OLO.Components.BUTTON_SIZE | OLO.Components.LINK_SIZE;
    @Input() public disabled: boolean = false;
    @Input() public triggerType: 'button' | 'link' = 'button';

    @Input() public selected: OLO.Components.DropDown.IDropDownOption;
    @Output() public onDropdownToggle: EventEmitter<boolean> = new EventEmitter();
    @Output() public onDropdownSelected: EventEmitter<OLO.Components.DropDown.IDropDownOption> = new EventEmitter();

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    public dropdownToggle($event: boolean): void {
        this.onDropdownToggle.emit($event);
    }

    public dropdownSelected($event: OLO.Components.DropDown.IDropDownOption): void {
        this.onDropdownSelected.emit($event);
    }

    public get isFutureOrder(): boolean {
        return this.config.futureOrders === true;
    }

    public get isDisabled(): boolean {
        if (this.optionsAmount !== null) {
            return this.disabled || !this.optionsAmount || !this.options?.length;
        } else {
            return this.disabled || !this.options?.length;
        }
    }
}
